<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de prioridade">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/painel-senha/prioridade/List'

export default {
    components: { List },
}
</script>